export default "__VITE_ASSET__7b577e0b__"